import React from 'react'

export default function Company() {
  return (
    <div>
        <div className="container">
            <div className="row">
                <div className="col text-center">
                    <h1>About Company</h1>
                </div>
            </div>
        </div>
    </div>
  )
}
